'use client';

import { type PropsWithChildren } from 'react';

import type { NavBar } from '@/api/types/navigationTypes';
import { getUserInfo } from '@/features/auth/client';
import { isMvpdAuthenticated } from '@/features/auth/isMvpdAuthenticated';
import { signInMvpd } from '@/features/auth/signin';

import { Button } from '../UI/Button';
import { NavigationItem } from './NavigationItem';

interface NavBarProps {
  navBar?: NavBar;
}

export function NavigationBar({ navBar, children }: PropsWithChildren<NavBarProps>): React.ReactNode {
  if (!navBar) {
    return null;
  }

  const { accessToken } = getUserInfo();

  return (
    <nav data-testid="NavigationBar" className="scrollbar-custom flex w-full overflow-auto">
      <ul className="flex w-full flex-col items-start gap-y-[7px] md:flex-row md:items-center md:gap-x-[32px] md:gap-y-0">
        {!isMvpdAuthenticated(accessToken) ? (
          <Button
            variant="transparent"
            size="pT"
            dataAnalytics="tv-provider-button"
            onClick={signInMvpd}
            className="ml-[53px] whitespace-nowrap py-4 font-FoxOneAeroBold text-[17px]/[22px] text-base-white hover:opacity-100 md:hidden"
          >
            <span className="!font-extrabold">Connect TV Provider</span>
          </Button>
        ) : null}
        {navBar.subitems?.map((item, index) => (
          <NavigationItem key={item.nav_item_id} navItem={item} isLast={index === (navBar.subitems?.length ?? 0) - 1} />
        ))}
        {children}
      </ul>
    </nav>
  );
}
